import { useQuery } from '@tanstack/react-query';
import GeospatialQueries, { GEOSPATIAL_QUERY_KEYS } from '../query';

export const useSuggest = (text: string, location: string, usOnly: boolean = false) => {
  return useQuery({
    queryKey: [GEOSPATIAL_QUERY_KEYS.SUGGEST, location, usOnly, text],
    queryFn: () => GeospatialQueries.suggest(text, location, usOnly),
    enabled: !!text,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
